import { CHAT_END_USER_RESET_DATA, SET_END_USER_CHAT_ICONS, SET_END_USER_CHAT_WINDOWS, SET_END_USER_ROOMS_INIT_NOTI, SET_END_USER_ROOMS_NOTI, SET_END_USER_ROOM_ID_LIST } from "../actions/types";

const initialState = {
  chatWindows: [],
  chatIcons: [],
  roomIdList: [],
  roomsNoti: [],
  roomsInitNoti: [],
};

const endUserChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_END_USER_CHAT_WINDOWS: {
      const { chatWindows } = action.payload;
      return { ...state, chatWindows };
    }
    case SET_END_USER_CHAT_ICONS: {
      const { chatIcons } = action.payload;
      return { ...state, chatIcons };
    }
    case SET_END_USER_ROOM_ID_LIST: {
      const { roomIdList } = action.payload;
      return { ...state, roomIdList };
    }
    case SET_END_USER_ROOMS_NOTI: {
      const { roomsNoti } = action.payload;
      return { ...state, roomsNoti };
    }
    case SET_END_USER_ROOMS_INIT_NOTI: {
      const { roomsInitNoti } = action.payload;
      return { ...state, roomsInitNoti };
    }
    case CHAT_END_USER_RESET_DATA: {
      return {
        chatWindows: [],
        chatIcons: [],
        roomIdList: [],
        roomsNoti: [],
        roomsInitNoti: [],
      };
    }
    default: {
      return state;
    }
  }
}
export default endUserChatReducer;